import { DEBUG, PATH } from '../constants';


const base = PATH;
const debug = DEBUG;

export async function getAllRepLibres() {
  try {
    const response = await fetch(base + 'rep-libres');
    return await response.json();
  } catch (error) {
    console.error('Erreur getAllRepLibres', error);
    throw error;
  }
}
  
export async function getAllRepLibresByQuestion(q) {
  try {
    const response = await fetch(base + 'rep-libres/q/' + q);
    return await response.json();
  } catch (error) {
    console.error('Erreur getAllRepLibresByQuestion', error);
    throw error;
  }
}
    
export async function createRepLibre(questionId, txt) {
  console.log(txt);
  try {
    const authToken = localStorage.getItem("authToken"); // Récupération du token
      //Remplacer libelle par un encodage des possibilités au format json
    const response = await fetch(base + 'rep-libres/insert', {
      method: 'POST',
      credentials: "include", // Permet d'envoyer les cookies avec chaque requête, si http-only
      headers: { 'Content-Type': 'application/x-www-form-urlencoded',
        'Authorization': `Bearer ${authToken}` // Ajout du token dans le header => penser à modifier .htaccess de l'API pour autoriser cet en-tête
      },
      body: new URLSearchParams({ reponses: JSON.stringify(txt), id_question: questionId }),
    });
    return await response.json();
  } catch (error) {
    console.error('Erreur createRepLibre', error);
    throw error;
  }
}

export async function updateReponse(id, texte) {
  try {
    const authToken = localStorage.getItem("authToken"); // Récupération du token
      const response = await fetch(base + 'rep-libres/update', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json',
          'Authorization': `Bearer ${authToken}` // Ajout du token dans le header => penser à modifier .htaccess de l'API pour autoriser cet en-tête
        },
        body: JSON.stringify({
          id: id,
            reponses: texte
        })
      });
      return await response.json();
  } catch (error) {
    console.error('Erreur updateReponse (libre)', error);
    throw error;
  }
}

export async function deleteReponse(questionId) {
  try {
    const authToken = localStorage.getItem("authToken"); // Récupération du token
    const response = await fetch(base + 'rep-libres/delete', 
      {
        method: 'POST',
        headers: { 'Content-Type': 'application/x-www-form-urlencoded',
          'Authorization': `Bearer ${authToken}` // Ajout du token dans le header => penser à modifier .htaccess de l'API pour autoriser cet en-tête
        },
        body: new URLSearchParams({ id: questionId }),
    });
    return await response.json();
  } catch (error) {
    console.error('Erreur deleteReponse (libre)', error);
    throw error;
  }
}
